/* tslint:disable */
import {
  Teomemppersonal
} from '../index';

declare var Object: any;
export interface StsmartnoticememberInterface {
  "smartId"?: number;
  "userId"?: number;
  "fullname"?: string;
  "picture"?: string;
  "companyId"?: number;
  "codename"?: string;
  "id"?: number;
  rel_personal?: Teomemppersonal;
}

export class Stsmartnoticemember implements StsmartnoticememberInterface {
  "smartId": number;
  "userId": number;
  "fullname": string;
  "picture": string;
  "companyId": number;
  "codename": string;
  "id": number;
  rel_personal: Teomemppersonal;
  constructor(data?: StsmartnoticememberInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Stsmartnoticemember`.
   */
  public static getModelName() {
    return "Stsmartnoticemember";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Stsmartnoticemember for dynamic purposes.
  **/
  public static factory(data: StsmartnoticememberInterface): Stsmartnoticemember{
    return new Stsmartnoticemember(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Stsmartnoticemember',
      plural: 'Stsmartnoticemembers',
      path: 'Stsmartnoticemembers',
      properties: {
        "smartId": {
          name: 'smartId',
          type: 'number'
        },
        "userId": {
          name: 'userId',
          type: 'number'
        },
        "fullname": {
          name: 'fullname',
          type: 'string'
        },
        "picture": {
          name: 'picture',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "codename": {
          name: 'codename',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        rel_personal: {
          name: 'rel_personal',
          type: 'Teomemppersonal',
          model: 'Teomemppersonal'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Stsmartnoticemember.ts